/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrderEntry } from './OrderEntry';
import {
    OrderEntryFromJSON,
    OrderEntryFromJSONTyped,
    OrderEntryToJSON,
} from './OrderEntry';

/**
 * Representation of an Entry Group
 * @export
 * @interface EntryGroup
 */
export interface EntryGroup {
    /**
     * List of order entries
     * @type {Array<OrderEntry>}
     * @memberof EntryGroup
     */
    entries?: Array<OrderEntry>;
    /**
     * List of child entry groups
     * @type {Array<EntryGroup>}
     * @memberof EntryGroup
     */
    entryGroups?: Array<EntryGroup>;
    /**
     * Identifier of the entry group
     * @type {number}
     * @memberof EntryGroup
     */
    entryGroupNumber?: number;
    /**
     * Label for the entry group
     * @type {string}
     * @memberof EntryGroup
     */
    label?: string;
    /**
     * Indicates if the entry group is in an error state
     * @type {boolean}
     * @memberof EntryGroup
     */
    erroneous?: boolean;
    /**
     * Indicates type of the group, possible values are STANDALONE, CONFIGURABLEBUNDLE or any customer implemented type for any new provider
     * @type {string}
     * @memberof EntryGroup
     */
    type?: string;
}

/**
 * Check if a given object implements the EntryGroup interface.
 */
export function instanceOfEntryGroup(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EntryGroupFromJSON(json: any): EntryGroup {
    return EntryGroupFromJSONTyped(json, false);
}

export function EntryGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntryGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entries': !exists(json, 'entries') ? undefined : ((json['entries'] as Array<any>).map(OrderEntryFromJSON)),
        'entryGroups': !exists(json, 'entryGroups') ? undefined : ((json['entryGroups'] as Array<any>).map(EntryGroupFromJSON)),
        'entryGroupNumber': !exists(json, 'entryGroupNumber') ? undefined : json['entryGroupNumber'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'erroneous': !exists(json, 'erroneous') ? undefined : json['erroneous'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function EntryGroupToJSON(value?: EntryGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entries': value.entries === undefined ? undefined : ((value.entries as Array<any>).map(OrderEntryToJSON)),
        'entryGroups': value.entryGroups === undefined ? undefined : ((value.entryGroups as Array<any>).map(EntryGroupToJSON)),
        'entryGroupNumber': value.entryGroupNumber,
        'label': value.label,
        'erroneous': value.erroneous,
        'type': value.type,
    };
}

